import { render, staticRenderFns } from "./StarRating.vue?vue&type=template&id=6c86c880"
import script from "./StarRating.vue?vue&type=script&lang=js"
export * from "./StarRating.vue?vue&type=script&lang=js"
import style0 from "./StarRating.vue?vue&type=style&index=0&id=6c86c880&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports